import { Policy } from "@/modules/groups/interfaces/policy";
import { MaybeRef, computed, isRef } from "vue";
import { PolicyObjectMap } from "@/interfaces/PolicyObjectMap";

const usePolicyObjectMapper = (groupPolicies: MaybeRef<Policy[]>) => {
  const policies = isRef(groupPolicies) ? groupPolicies : computed(() => []);

  const policyObjectMap = computed(() => {
    const applicablePolicies = policies.value.map(({ name }) => name);

    const draft = policies.value.filter((policy) =>
      applicablePolicies.includes(policy.name)
    );

    return applicablePolicies.reduce((acc, policyName) => {
      const matchingPolicy = draft.find((policy) => policy.name === policyName);
      if (!matchingPolicy) return acc;

      acc[policyName as keyof PolicyObjectMap] = matchingPolicy || null;
      return acc;
    }, {} as PolicyObjectMap);
  });

  return { policyObjectMap };
};

export default usePolicyObjectMapper;
